import { takeEvery, call, put } from 'redux-saga/effects';
import { hasUserAlreadyBeenAssignedToAbTestGroup, setAbTestingCookie } from '../core/util/abTest';
import {
  abTestingGroupFetchingAssignment,
  abTestingGroupAssignmentError,
  abTestingGroupAssignmentReceived,
} from '../ducks/abTests';
import { getAbTestingGroupAssignmentUrl } from '../core/dapi/abTesting';
import { apiGet } from '../core/dapi';
import { AbTestGroupDefaults } from '../constants/abTesting';

export const ASSIGN_TO_AB_TESTING_GROUP = 'saga/ASSIGN_TO_AB_TESTING_GROUP';

export function* assignToAbTestingGroup(testName, cookieName, groupOptions = [], weights = []) {
  if (!hasUserAlreadyBeenAssignedToAbTestGroup(cookieName)) {
    try {
      yield put(abTestingGroupFetchingAssignment(true));

      const abTestGroupAssignment = yield call(
        apiGet,
        getAbTestingGroupAssignmentUrl(groupOptions, weights)
      );

      yield put(abTestingGroupAssignmentReceived(testName, abTestGroupAssignment));
      setAbTestingCookie(testName, cookieName, abTestGroupAssignment);
      yield put(abTestingGroupFetchingAssignment(false));
    } catch (e) {
      yield put(abTestingGroupAssignmentError(testName, e));
      setAbTestingCookie(testName, cookieName, AbTestGroupDefaults.CONTROL);
      yield put(abTestingGroupFetchingAssignment(false));
    }
  }
}

function* rootSaga() {
  yield takeEvery(ASSIGN_TO_AB_TESTING_GROUP, assignToAbTestingGroup);
}

export { rootSaga as default };
